enum FigureType {
  Bishop = 'Bishop',
  King = 'King',
  Knight = 'Knight',
  Pawn = 'Pawn',
  Queen = 'Queen',
  Rook = 'Rook'
}

export default FigureType